import { Link } from "react-router-dom";

export default function Privacy(){
    return <Link to={"https://www.freeprivacypolicy.com/live/0fff8685-9a1a-4a73-92a1-5df390ac1f6d"}>Privacy Policy
    </Link>
}